export const CATEGORY_ADHERENCE = '6367b865-bf13-4ba9-9f80-f80585348bb9';
export const SENSOR_TYPE_ADHERENCE = '396c14fa-e2e3-4510-914e-b0d7fe56bb49';

export const ALLOWED_CHARACTERS_REGEX = /[^a-z\d !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~\\]/i;

export const FIG_APPID = 'a373a097-5d4d-4c60-abf1-2184804226e1';
export const MGL_ORGANIZATION_ID = 'fe704f3a-39f2-4680-8184-c3852d5fcbeb';
